import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      name: 'billing_settings_index',
      meta: {
        permissions: ['administrator'],
      },
      redirect: to => ({
        name: 'plan_settings_index',
        params: { accountId: to.params.accountId },
      }),
    },
  ],
};
